"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../Theme/constant");

var stepperConfig = _propTypes.default.shape({
  labelColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
  customProperties: _propTypes.default.object,
  accessible: _propTypes.default.bool,
  disableDecrement: _propTypes.default.bool,
  disableIncrement: _propTypes.default.bool,
  stepperButtonConfig: _propTypes.default.shape({
    stepperAdd: _propTypes.default.object,
    stepperMinus: _propTypes.default.object
  })
});

var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    expanderTitle: _propTypes.default.string,
    expand: _propTypes.default.bool,
    enableToggle: _propTypes.default.bool,
    data: _propTypes.default.shape({
      labels: _propTypes.default.object,
      minPassengers: _propTypes.default.string,
      maxPassengers: _propTypes.default.string,
      adult: _propTypes.default.shape({
        type: _propTypes.default.string,
        min: _propTypes.default.string,
        max: _propTypes.default.string
      }),
      child: _propTypes.default.shape({
        type: _propTypes.default.string,
        min: _propTypes.default.string,
        max: _propTypes.default.string
      }),
      infant: _propTypes.default.shape({
        type: _propTypes.default.string,
        min: _propTypes.default.string,
        max: _propTypes.default.string
      }),
      passengerCount: _propTypes.default.shape({
        adult: _propTypes.default.number,
        child: _propTypes.default.number,
        infant: _propTypes.default.number
      }),
      stepperConfig: stepperConfig,
      childList: _propTypes.default.array,
      ageList: _propTypes.default.array
    }),
    showRemove: _propTypes.default.bool,
    onChangeData: _propTypes.default.func,
    handleClick: _propTypes.default.func,
    onRemove: _propTypes.default.func,
    customProperties: _propTypes.default.object,
    accessible: _propTypes.default.bool,
    isShowChildAgeInput: _propTypes.default.bool,
    isShowInfantSelect: _propTypes.default.bool,
    changeChildAge: _propTypes.default.func
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    onChangeData: function onChangeData() {},
    handleClick: function handleClick() {},
    changeChildAge: function changeChildAge() {},
    onRemove: function onRemove() {},
    accessible: true,
    expand: false,
    enableToggle: false,
    isShowChildAgeInput: false,
    isShowInfantSelect: true
  }
};
exports.default = _default;